// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loading_loader__SShnr"};